import { assertEvent, assign } from 'xstate5';

import { increaseDressingWeight } from '../../helpers';
import type { CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Handles the logic to increase the weight of a specific dressing ingredient
 * within the mixed dressing details.
 */
export const increaseMixedDressingWeight: CustomizationMachineAction = assign(
  (args) => {
    const { event, context } = args;
    const { mixedDressingDetails } = context;

    assertEvent(event, 'customization.dressing.increase-weight');

    const { ingredientId } = event;

    return {
      mixedDressingDetails: increaseDressingWeight({ ingredientId, mixedDressingDetails }), // prettier-ignore
    };
  },
);
